import NextLink from 'next/link';
import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { ChevronRight } from '@eqi-investimentos/icons/web';
import { Box, Button, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@eqi-investimentos/react';
import { InvestRepository, useGetListBrokers } from '@/repositories/invest/InvestRepository';
import { Icon } from '@/components/atoms/Icon';
import { Thumb } from '@/components/atoms/Thumb';
import { IfRender, MapRender } from '@/utils/jsx';
import { LoadingBrokerSection } from './Skeleton';
export const BrokersSection = () => {
  const {
    t
  } = useTranslation('common');
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const investRepository = new InvestRepository();
  const {
    data: listBrokers = [],
    status
  } = useGetListBrokers(investRepository);
  const tabsOption = Array.from({
    length: 4
  }).map((_, index) => ({
    name: t(`screens.invest.redirectBroker.tabs.option${index}.title`),
    type: t(`screens.invest.redirectBroker.tabs.option${index}.type`)
  }));
  const brokersTabSelected = listBrokers.filter(({
    type
  }) => type === tabsOption[activeTabIndex]?.type);
  return <Box overflowX="hidden" data-sentry-element="Box" data-sentry-component="BrokersSection" data-sentry-source-file="index.tsx">
      <IfRender condition={status === 'pending'} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
        <LoadingBrokerSection data-sentry-element="LoadingBrokerSection" data-sentry-source-file="index.tsx" />
      </IfRender>
      <IfRender condition={status !== 'pending'} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
        <Flex flexDir="column" sx={{
        '&::-webkit-scrollbar': {
          display: 'none'
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none'
      }} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Text size="2xl" fontWeight="semibold" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
            {t('screens.invest.redirectBroker.title')}
          </Text>

          <Box py="l" pb="5xl" w="full" data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <Tabs data-sentry-element="Tabs" data-sentry-source-file="index.tsx">
              <TabList overflowX="scroll" sx={{
              '&::-webkit-scrollbar': {
                display: 'none'
              },
              scrollbarWidth: '0.4px'
            }} data-sentry-element="TabList" data-sentry-source-file="index.tsx">
                <MapRender items={tabsOption} render={({
                name
              }, index) => <Tab key={index} onClick={() => setActiveTabIndex(index)}>
                      {name}
                    </Tab>} data-sentry-element="MapRender" data-sentry-source-file="index.tsx" />
              </TabList>
              <TabPanels data-sentry-element="TabPanels" data-sentry-source-file="index.tsx">
                <MapRender items={brokersTabSelected} render={({
                id,
                name,
                url_campaign,
                thumb_img
              }) => <TabPanel>
                      <Flex as={NextLink} href={url_campaign} target="_blank" rel="noopener noreferrer" key={id} flexDir="row" gap="s" borderBottom="1px solid" borderColor="border.secondary" py="s" align="center" justify="space-between" px="s" _hover={{
                  bg: 'background.brandLight'
                }}>
                        <Flex gap="xs" flexDir="row" align="center">
                          <Thumb src={thumb_img || ''} width={40} height={40} fit="cover" alt={name} />
                          <Text size="l" color="content.primary">
                            {name}
                          </Text>
                        </Flex>
                        <Icon iconName="ChevronRight" w={24} h={24} color="content.brand" />
                      </Flex>
                    </TabPanel>} data-sentry-element="MapRender" data-sentry-source-file="index.tsx" />
              </TabPanels>
            </Tabs>
          </Box>
        </Flex>
      </IfRender>
    </Box>;
};